import { Action } from '@ngrx/store';

export enum CoverActionTypes {
  Load = '[API] Load covers',
  LoadSuccess = '[API] Load covers success',
  LoadFail = '[API] Load covers fail',
  Create = '[API] Create covers ',
  CreateSuccess = '[API] Create covers success',
  CreateFail = '[API] Create covers fail',

  ExportGroupCovers = '[API] Export group covers',
  ExportGroupCoversSuccess = '[API] Export group covers success',
  ExportGroupCoversUpdate = '[API] Export group covers update',
  ExportGroupCoversFail = '[API] Export group covers fail',
  ExportGroupCoversDownload = '[API] Export group covers download',
  ExportGroupCoversDownloadSuccess = '[API] Export group covers download success',
  ExportGroupCoversDownloadFail = '[API] Export group covers download fail',
}

export class Load implements Action {
  readonly type = CoverActionTypes.Load;
  constructor(public options?: any) { }
}

export class LoadSuccess implements Action {
  readonly type = CoverActionTypes.LoadSuccess;
  constructor(public cover: any) {}
}

export class LoadFail implements Action {
  readonly type = CoverActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class Create implements Action {
  readonly type = CoverActionTypes.Create;
  constructor(public data: any) {}
}

export class CreateSuccess implements Action {
  readonly type = CoverActionTypes.CreateSuccess;
  constructor(public cover?: any) {}
}

export class CreateFail implements Action {
  readonly type = CoverActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class ExportGroupCovers implements Action {
  readonly type = CoverActionTypes.ExportGroupCovers;
  constructor(public data: any) { }
}

export class ExportGroupCoversSuccess implements Action {
  readonly type = CoverActionTypes.ExportGroupCoversSuccess;
  constructor(public data: any) { }
}

export class ExportGroupCoversUpdate implements Action {
  readonly type = CoverActionTypes.ExportGroupCoversUpdate;
  constructor(public data: any) { }
}

export class ExportGroupCoversFail implements Action {
  readonly type = CoverActionTypes.ExportGroupCoversFail;
  constructor(public error: any) { }
}

export class ExportGroupCoversDownload implements Action {
  readonly type = CoverActionTypes.ExportGroupCoversDownload;
  constructor(public downloadUrl: string, public name: string, public total?: number) { }
}

export class ExportGroupCoversDownloadSuccess implements Action {
  readonly type = CoverActionTypes.ExportGroupCoversDownloadSuccess;
  constructor() { }
}

export class ExportGroupCoversDownloadFail implements Action {
  readonly type = CoverActionTypes.ExportGroupCoversDownloadFail;
  constructor(public error: any) { }
}


export type CoverActionsUnion =
  | Load
  | LoadFail
  | LoadSuccess
  | Create
  | CreateSuccess
  | CreateFail
  | ExportGroupCovers
  | ExportGroupCoversSuccess
  | ExportGroupCoversUpdate
  | ExportGroupCoversFail
  | ExportGroupCoversDownload
  | ExportGroupCoversDownloadSuccess
  | ExportGroupCoversDownloadFail